const vi = {
  10000001: 'Lễ kỷ niệm 2 năm SuperEx',
  10000002: 'Đăng nhập để nhận phần thưởng lớn!',
  10000003: 'Theo số lượng người tham gia, số lượng người tham gia càng lớn thì tổng giải thưởng sẽ được mở khóa càng lớn, lên tới 10 000USDT',
  10000004: 'Kỷ niệm hai năm của SuperEx',
  10000005: 'Giành được 20.000 USDT trong Cuộc thi giao dịch hợp đồng tương lai',
  10000006: `Cuộc thi xếp hạng khối lượng giao dịch: Mở khóa giải thưởng cao nhất là quỹ tiền thưởng <span style="color: #ffc72b;">10,000</span> USDT`,
  10000007: 'Giải vô địch tương lai',
  10000008: 'Giành được 20.000 USDT trong Cuộc thi giao dịch hợp đồng tương lai',
}

export default vi



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/vi.js